import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-[#FAFAFA] pt-20 pb-20 lg:pt-28 lg:pb-28" data-id="element-213">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-orange-100/40 rounded-full blur-3xl -z-10" data-id="element-214" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[600px] h-[600px] bg-teal-100/40 rounded-full blur-3xl -z-10" data-id="element-215" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="max-w-4xl mx-auto text-center" data-id="element-217">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-218">
            <span className="inline-block py-1 px-3 rounded-full bg-orange-100 text-[#FF6B35] text-sm font-semibold mb-6 border border-orange-200" data-id="element-219">
              New: Real-time Check-in Sync
            </span>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight mb-8 leading-[1.1]" data-id="element-220">
              Fitness Reimbursement, <br className="hidden sm:block" data-id="element-221" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FF8E53]" data-id="element-222">
                Simplified.
              </span>
            </h1>
            <p className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-223">
              Automate your corporate wellness programs with ActiveTally.
              Seamless member verification, instant check-in tracking, and smart
              reconciliation for modern fitness program providers.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-224">
              <Button size="lg" className="w-full sm:w-auto group" data-id="element-225">
                Get Started
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-226" />
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}